(() => {
  const modules = (window.TuMejorEtapa ||= {}).modules ||= {};
  if (modules.proceso) { modules.proceso.initAll(document); return; }

  const selector = '[data-tu-mejor-etapa-section="proceso"]';
  const cleanups = new WeakMap();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const show = (root) => {
    root.style.setProperty('--tu-mejor-etapa-line', '1');
    root.querySelectorAll('.tu-mejor-etapa-proceso__icon,.tu-mejor-etapa-proceso__card,.tu-mejor-etapa-proceso__cta').forEach((node) => {
      node.style.opacity = '1'; node.style.transform = 'none'; node.style.filter = 'none'; node.style.clipPath = 'none'; node.style.boxShadow = '';
    });
  };
  const init = (root) => {
    if (!root || cleanups.has(root)) return;
    const cleanup = [];
    const timeline = root.querySelector('.tu-mejor-etapa-proceso__timeline');
    const steps = [...root.querySelectorAll('.tu-mejor-etapa-proceso__step')];
    const cta = root.querySelector('.tu-mejor-etapa-proceso__cta');
    if (!timeline || !steps.length || reduced() || !('IntersectionObserver' in window) || typeof Element === 'undefined' || !Element.prototype.animate) { show(root); cleanups.set(root, cleanup); return; }

    root.classList.add('tu-mejor-etapa-proceso-js');
    root.style.setProperty('--tu-mejor-etapa-line', '0');
    let lineTimer = null;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || entry.intersectionRatio < .3) return;
      lineTimer = window.setTimeout(() => root.style.setProperty('--tu-mejor-etapa-line', '1'), 50);
      steps.forEach((step, index) => {
        const icon = step.querySelector('.tu-mejor-etapa-proceso__icon');
        const card = step.querySelector('.tu-mejor-etapa-proceso__card');
        const at = 220 + index * 260;
        icon?.animate([
          { opacity: 0, transform: 'translateY(18px) scale(.46) rotate(-8deg)', filter: 'blur(.24rem)' },
          { opacity: 1, transform: 'translateY(0) scale(1) rotate(0deg)', filter: 'blur(0)' },
        ], { duration: 680, delay: at, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'forwards' });
        card?.animate([
          { opacity: 0, transform: 'translateY(38px) scale(.95)', clipPath: 'inset(0 0 100% 0 round 2rem)' },
          { opacity: 1, transform: 'translateY(0) scale(1)', clipPath: 'inset(0 0 0% 0 round 2rem)' },
        ], { duration: 860, delay: at + 120, easing: 'cubic-bezier(.165,.84,.44,1)', fill: 'forwards' });
        icon?.animate([
          { boxShadow: '0 0 0 0 rgba(127,169,174,.34)' },
          { boxShadow: '0 0 0 1rem rgba(127,169,174,0)' },
        ], { duration: 550, delay: at + 80, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'none' });
      });
      cta?.animate([{ opacity: 0, transform: 'translateY(22px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 700, delay: 1750, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'forwards' });
      observer.disconnect();
    }, { threshold: [.18, .3, .45], rootMargin: '0px 0px -18% 0px' });
    observer.observe(timeline);
    cleanup.push(() => {
      observer.disconnect(); if (lineTimer) window.clearTimeout(lineTimer);
      root.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
      root.classList.remove('tu-mejor-etapa-proceso-js'); show(root);
    });
    cleanups.set(root, cleanup);
  };
  const destroy = (root) => { (cleanups.get(root) || []).forEach((fn) => fn()); cleanups.delete(root); };
  const initAll = (container = document) => { if (container.matches?.(selector)) init(container); container.querySelectorAll?.(selector).forEach(init); };
  modules.proceso = { initAll, destroy };
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => { if (event.target.matches?.(selector)) destroy(event.target); event.target.querySelectorAll?.(selector).forEach(destroy); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
})();
